import { useRef } from 'react'
import { Plus } from 'lucide-react'
import { useEditorStore } from '../../../store/editorStore'

/**
 * UI_MK2_PHASE1.md §3-3: "ドロップゾーンはビン全体（ドラッグ中に枠が光る）＋
 * 上部の小ボタン" — the whole-bin drop target lives in AssetBin.tsx now, so
 * this is just the small click-to-browse button (file drops here still work
 * too: they simply bubble up to the bin's own onDrop, no handler needed here).
 */
export function UploadDropzone() {
  const uploadFiles = useEditorStore((s) => s.uploadFiles)
  const inputRef = useRef<HTMLInputElement>(null)

  function handleFiles(files: FileList | null) {
    if (!files || files.length === 0) return
    uploadFiles(Array.from(files))
  }

  return (
    <div>
      <button
        onClick={() => inputRef.current?.click()}
        data-testid="upload-dropzone"
        className="w-full flex items-center justify-center gap-1.5 rounded border border-dashed border-ink-border hover:border-white/30 hover:bg-white/5 px-2 py-1.5 text-[11px] text-text-muted transition-colors"
      >
        <Plus size={13} />
        素材を追加（mp4/mov）
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="video/*"
        multiple
        className="hidden"
        onChange={(e) => {
          handleFiles(e.target.files)
          e.target.value = ''
        }}
      />
    </div>
  )
}
